// eslint-disable-next-line import/prefer-default-export
export const JOURNAL_REGLEMENT = {
  titre: 'Journal des règlements',
  racine: 'Accueil',
  table: {
    colonnes: {
      dateReglement: 'Date de règlement',
      domiciliationBancaire: 'Domiciliation bancaire',
      nomTire: 'Nom du tiré',
      referenceTire: 'Référence de paiement',
      client: 'Client',
      commercial: 'Commercial(e)',
      compteComptable: 'Compte comptable du client',
      montantRegle: 'Montant réglé',
      modeReglement: 'Mode de règlement',
      codeFactureOuContrat: 'Facture',
      montantTtcAPayer: 'Restant dû',
      montantLettre: 'Montant lettré',
    },
  },
  filtre: {
    titre: 'Filtre',
    sousTitre: 'Les filtres seront appliqués à la liste',
    dates: 'Période sur la date de règlement',
    domiciliationBancaire: 'Domiciliation bancaire',
    referenceTire: 'Référence de paiement',
    nomTire: 'Nom du tiré',
    borneMontantRegle: 'Montant réglé',
    client: 'Client',
    compteComptable: 'Compte comptable du client',
    codeFactureOuContrat: 'Code facture',
    commercial: 'Commercial de la facture',
    actions: {
      appliquer: 'Appliquer',
      reinitialiser: 'Réinitialiser',
    },
  },
  export: {
    titre: 'Exporter le journal des règlements',
  },
};
